// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.consumption-forecast {
  position: relative; /* Ensure child elements are positioned relative to this container */
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: 1px solid white;
  padding: 1rem;
  gap: 1rem;
}
.consumption-forecast__selectors {
  height: 5%;
}
.consumption-forecast__chart {
  height: 25%;
}
.consumption-forecast__preview-table {
  height: 50vh;
}
.consumption-forecast__boxes-selector {
  margin: 1rem 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
}
.consumption-forecast__boxes-selector__title {
  font-size: 1rem;
  font-weight: 400;
}
.consumption-forecast__boxes-selector__button {
  width: 100px;
  justify-content: center;
  align-items: center;
  height: 40px;
  background-color: #4F4BFF;
  color: white;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}

.separator {
  width: 25%;
  height: 1px;
  background-color: #E0E4ED;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(193, 193, 193, 0.32);
  z-index: 100;
}

.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 101;
}

.forecast-data-filters-row {
  width: 50%;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}
.forecast-data-filters-row .shop-dropdown {
  width: fit-content;
  min-width: 10rem;
  border-radius: 8px;
  border-color: #E0E4ED;
}
.forecast-data-filters-row .shop-selected, .forecast-data-filters-row .shop {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.forecast-data-filters-row .shop-selected__details__name, .forecast-data-filters-row .shop__details__name {
  font-size: 0.9rem;
  color: #4F5566;
}
.forecast-data-filters-row .p-calendar .p-inputtext {
  width: fit-content;
  min-width: 10rem;
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/consumption-forecast/consumption-forecast.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA,EAAA,oEAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;AACJ;AAAI;EACI,UAAA;AAER;AAAI;EACI,WAAA;AAER;AAAI;EACI,YAAA;AAER;AAAI;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAER;AADQ;EACI,eAAA;EACA,gBAAA;AAGZ;AADQ;EACI,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAGZ;;AACA;EACI,UAAA;EACA,WAAA;EACA,yBAAA;AAEJ;;AAAA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,YAAA;AAGJ;;AAAA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,YAAA;AAGJ;;AADA;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAIJ;AAFI;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AAIR;AADI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAGR;AAAY;EACI,iBAAA;EACA,cAAA;AAEhB;AAGI;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;AADR","sourcesContent":[".consumption-forecast {\n    position: relative; /* Ensure child elements are positioned relative to this container */\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    border: 1px solid white;\n    padding: 1rem;\n    gap: 1rem;\n    &__selectors{\n        height: 5%;\n    }\n    &__chart{\n        height: 25%;\n    }\n    &__preview-table{\n        height: 50vh;\n    }\n    &__boxes-selector{\n        margin: 1rem 0;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 1rem;\n        &__title{\n            font-size: 1rem;\n            font-weight: 400;\n        }\n        &__button{\n            width: 100px;\n            justify-content: center ;\n            align-items: center;\n            height: 40px;\n            background-color:#4F4BFF;\n            color: white;\n            border-color: #DEDEDE;\n            border-radius: 6px;\n            font-size: 0.85rem;\n        }\n    }\n}\n.separator{\n    width: 25%;\n    height: 1px;\n    background-color: #E0E4ED;\n}\n.mask {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(193, 193, 193, 0.32);\n    z-index: 100;\n}\n\n.popup {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: white;\n    padding: 2rem;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    z-index: 101;\n}\n.forecast-data-filters-row{\n    width: 50%;\n    display: flex;\n    flex-direction: row;\n    gap:0.5rem;\n\n    .shop-dropdown{\n        width: fit-content;\n        min-width: 10rem;\n        border-radius: 8px;\n        border-color:#E0E4ED ;\n    }\n\n    .shop-selected, .shop{\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n    \n        &__details{\n            &__name{\n                font-size: 0.9rem;\n                color:#4F5566;\n            }\n        }\n    }\n    \n    .p-calendar .p-inputtext{\n        width:fit-content;\n        min-width: 10rem;\n        border-radius: 8px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
